import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { PrivateRoute } from "./private-route";
import { PublicRoute } from "./public-route";
import {
  SignIn,
  SignUp,
  UserProfile,
  ParentSignIn,
  StudentSignIn,
  EducatorSignIn,
  ParentSignUp,
  LinkChild,
  EducatorSignUp,
  ForgotPassword,
  EducatorPortal,
  EducatorSubmitContent,
  TeacherAccount,
  ChangePassword,
  StudentPortal,
  ResetPassword,
  AccountSetUp,
  PageNotFound,
  CreateClassroom,
} from "@app/modules";
import { CommonLayout } from "@app/components";
import { baseName } from "@app/providers";
import PaymentForm from "@app/modules/payment/payment";
// import OTPVerification from "@app/modules/signUp/educator/otp-verification";
import SchoolDistrict from '@app/modules/signUp/educator/educator-schoolDistrict-signup'
import AddStudents from "@app/modules/educator/add-students";
import ListStudents from "@app/modules/educator/list-students";
import Classrooms from "@app/modules/classrooms/classrooms";
import LinkedChildData from "@app/modules/userProfile/child-data"
import WFname from "../modules/extraPages/wfname"
import SSOLogin from "@app/components/SSOLogin/SSOLogin";
import googleClassroom from "@app/components/googleClassroom";
import cleverClassroom from "@app/components/cleverClassroom";
import GoogleStudents from "@app/components/googleClassroom/google-students";

const allRoutes = [
  {
    path: "/",
    component: SignIn,
    private: false,
    disablelogin: true,
  },
  {
    path: "/sign-in",
    component: SignIn,
    private: false,
    disablelogin: true,
  },
  {
    path: "/forgotpassword",
    component: ForgotPassword,
    private: false,
    disablelogin: true,
  },
  {
    path: "/sign-in/parent",
    component: ParentSignIn,
    private: false,
    disablelogin: true,
  },
  {
    path: "/sign-in/student",
    component: StudentSignIn,
    private: false,
    disablelogin: true,
  },
  {
    path: "/sign-in/educator",
    component: EducatorSignIn,
    private: false,
    disablelogin: true,
  },
  {
    path: "/resetpassword/:emailId/:passwordToken",
    component: ResetPassword,
    private: false,
    disablelogin: true,
  },
  {
    path: "/sign-up",
    component: SignUp,
    private: false,
    disablelogin: true,
  },
  {
    path: "/sign-up/parent",
    component: ParentSignUp,
    private: false,
    disablelogin: true,
  },
  {
    path: "/create-account/child",
    component: LinkChild,
    private: false,
    disablelogin: true,
  },
  {
    path: "/sign-up/educator",
    component: EducatorSignUp,
    private: false,
    disablelogin: true,
  },
  {
    path: "/account-setup/educator",
    component: TeacherAccount,
    private: false,
    disablelogin: true,
  },
  {
    path: "/account-setup",
    component: AccountSetUp,
    private: true,
  },
  {
    path: "/linked-child",
    component: LinkedChildData,
    private: true,
  },
  // {
  //   path: "/welcome-parent",
  //   component: WelcomeParent,
  //   private: true
  // },
  {
    path: "/create-avatar",
    component: StudentPortal,
    private: true,
  },

  {
    path: "/profile",
    component: UserProfile,
    private: true,
  },
  {
    path: "/educator",
    component: EducatorPortal,
    private: true,
  },
  {
    path: "/submit-content/educator",
    component: EducatorSubmitContent,
    private: true,
  },
  {
    path: "/change-password",
    component: ChangePassword,
    private: true,
  },
  {
    path: "/create-classroom",
    component: CreateClassroom,
    private: false,
  },
  {
    path: "/edit-classroom/:id",
    component: CreateClassroom,
    private: false,
  },
  {
    path: "/add-students/:id",
    component: AddStudents,
    private: false,
  },
  {
    path: "/list-students/:id",
    component: ListStudents,
    private: false,
  },
  {
    path: "/payment",
    component: PaymentForm,
    private: false,
  },
  /* {
    path: "/otp-verification",
    component: OTPVerification,
    private: false,
  }, */
  {
    path: "/account-setup/district",
    component: SchoolDistrict,
    private: false,
  },
  {
    path: "/classrooms",
    component: Classrooms,
    private: false,
  },
  {
    path: '/pagenotfound',
    component: PageNotFound,
    private: false,
  },
  {
    path: '/wfname',
    component: WFname,
    private: false,
  },
  {
    path: '/sso-authorize',
    component: SSOLogin,
    private: false,
  },
  {
    path: '/google-classrooms',
    component: googleClassroom,
    private: false,
  },
  {
    path: '/clever-classrooms',
    component: cleverClassroom,
    private: false,
  },
  {
    path: '/google-students/:id',
    component: GoogleStudents,
    private: false,
  }
];

export default function Routes() {
  return (
    <Router basename={baseName}>
      <CommonLayout />
      <Switch>
        {allRoutes.map((route: any, i: number) =>
          route.private ? (
            <PrivateRoute exact path={route.path} key={i}>
              <route.component />
            </PrivateRoute>
          ) : route.disablelogin ? (
            <PublicRoute exact path={route.path} key={i}>
              <route.component />
            </PublicRoute>
          ) : (
            <Route exact path={route.path} key={i}>
              <route.component />
            </Route>
          )
        )}
        <Route>
          <PageNotFound />
        </Route>
      </Switch>
    </Router>
  );
}
